import { render, staticRenderFns } from "./InfoTitle.vue?vue&type=template&id=203acfb1"
import script from "./InfoTitle.vue?vue&type=script&lang=js"
export * from "./InfoTitle.vue?vue&type=script&lang=js"
import style0 from "./InfoTitle.vue?vue&type=style&index=0&id=203acfb1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports